// ABOUTME: NavBar bell showing the live unread-notification count as a badge.
// ABOUTME: Opens the notification history panel on click; count updates in real time.

import { Badge, IconButton, NotificationsOutlinedIcon, Tooltip } from '@ds/coolshop';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { useNotifications } from '../hooks/useNotifications';
import { NotificationPanel } from './NotificationPanel';

export function NotificationBell() {
    const { formatMessage } = useIntl();
    const title = formatMessage({ id: 'notifications.title', defaultMessage: 'Notifications' });
    const [open, setOpen] = useState(false);
    // Default view lists unread only; the "All" tab also includes already-read notifications.
    const [showAll, setShowAll] = useState(false);
    const { notifications, unreadCount, loading, markAsRead, markAllAsRead, refetch } =
        useNotifications({
            onlyUnread: !showAll,
        });

    return (
        <>
            <Tooltip title={title} placement="bottom">
                {/* White round button, as in the app bar visuals. */}
                <IconButton
                    variant="contained"
                    color="primary"
                    invertedColor
                    aria-label={title}
                    onClick={() => setOpen(true)}
                >
                    {/* Counts above 99 collapse to "99+" so the badge never overflows the icon. */}
                    <Badge badgeContent={unreadCount} max={99} color="secondary">
                        <NotificationsOutlinedIcon />
                    </Badge>
                </IconButton>
            </Tooltip>
            <NotificationPanel
                open={open}
                onClose={() => setOpen(false)}
                notifications={notifications}
                unreadCount={unreadCount}
                loading={loading}
                showAll={showAll}
                onToggleShowAll={setShowAll}
                onMarkRead={markAsRead}
                onMarkAllRead={markAllAsRead}
                onRefetch={refetch}
            />
        </>
    );
}
